import React from 'react';
import { Stack } from 'react-bootstrap';
import { useForm, SubmitHandler } from 'react-hook-form';

import SVButton from 'components/elements/SVButton';

import DatePicker from './FormInput/date/ControlledDatePicker';

interface FormValues {
  date: string | null;
}

interface DatePickerFormProps {
  defaultValue?: string | null;
  onSave: (data: FormValues) => Promise<void> | void;
  label?: string;
}

const DatePickerForm: React.FC<DatePickerFormProps> = ({ defaultValue = null, onSave, label = '' }) => {
  const [isEditting, setEditting] = React.useState(false);
  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm<FormValues>({
    defaultValues: { date: defaultValue },
  });

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    await onSave(data);
    setEditting(false);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div>{label}</div>
      <Stack direction="horizontal" gap={2}>
        <DatePicker
          name="date"
          control={control}
          disabled={!isEditting || isSubmitting}
        />
        {isEditting ? (
          <Stack direction="horizontal" gap={1}>
            <SVButton
              variant="outline-secondary"
              size="sm"
              disabled={isSubmitting}
              onClick={() => {
                setEditting(false);
                reset({ date: defaultValue });
              }}
            >
              Cancel
            </SVButton>
            <SVButton
              type="submit"
              variant="secondary"
              size="sm"
              disabled={isSubmitting}
            >
              Save
            </SVButton>
          </Stack>
        ) : (
          <SVButton
            onClick={() => {
              setEditting(true);
            }}
            variant="secondary"
            size="sm"
          >
            Edit
          </SVButton>
        )}
      </Stack>
    </form>
  );
};

export default DatePickerForm;
